module.exports = __webpack_public_path__ + "static/media/right arrow icon.1483327d.svg";